<template>
  <div class="tdt-service-point-map" ref="map" style="width: 100%; height: 500px"></div>
</template>

<script>
import loadTDT from "@/utils/loadTDT.js";

export default {
  name: "TdtServicePointMap",

  props: {
    tk: {
      type: String,
      required: true,
    },
    center: {
      type: Array,
      default: () => [121.165666, 30.886314],
    },
    zoom: {
      type: Number,
      default: 17,
    },
    markers: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      map: null,
      T: null,
      markerList: [],
      currentInfoWindow: null,
    };
  },

  async mounted() {
    const T = await loadTDT(this.tk);
    this.T = T;

    this.$nextTick(() => {
      this.initMap();
    });
  },

  methods: {
    initMap() {
      const T = this.T;
      if (!T) return;

      this.map = new T.Map(this.$refs.map, { projection: "EPSG:3857" });

      const center = new T.LngLat(this.center[0], this.center[1]);
      this.map.centerAndZoom(center, this.zoom);
      this.map.enableScrollWheelZoom();

      this.map.addControl(new T.Control.Scale());
      this.map.addControl(new T.Control.Zoom());

      if (this.markers && this.markers.length > 0) {
        this.addMarkers();
      }
    },

    addMarkers() {
      const T = this.T;
      if (!T || !this.map) return;

      this.clearMarkers();

      this.markers.forEach((item, index) => {
        if (!item.lng || !item.lat) return;

        const point = new T.LngLat(Number(item.lng), Number(item.lat));

        const markerOpts = {};

        if (item.icon) {
          markerOpts.icon = new T.Icon({
            iconUrl: item.icon,
            iconSize: new T.Point(40, 45),
            iconAnchor: new T.Point(20, 45),
          });
        }

        const marker = new T.Marker(point, markerOpts);

        this.map.addOverLay(marker);

        const content = this.buildInfoWindowContent(item);
        const infoWindow = new T.InfoWindow(content, {
          offset: new T.Point(0, -30),
        });

        marker.addEventListener("mouseover", () => {
          this.openInfoWindow(infoWindow, point);
        });

        marker.addEventListener("click", () => {
          this.openInfoWindow(infoWindow, point);
        });

        this.markerList.push(marker);

        if (index === 0) {
          this.map.panTo(point);
          this.openInfoWindow(infoWindow, point);
        }
      });
    },

    openInfoWindow(infoWindow, point) {
      if (!this.map) return;

      if (this.currentInfoWindow) {
        this.map.closeInfoWindow(this.currentInfoWindow);
      }

      this.map.openInfoWindow(infoWindow, point);
      this.currentInfoWindow = infoWindow;
    },

    clearMarkers() {
      if (!this.map) return;

      if (this.currentInfoWindow) {
        this.map.closeInfoWindow(this.currentInfoWindow);
        this.currentInfoWindow = null;
      }

      this.markerList.forEach((marker) => {
        this.map.removeOverLay(marker);
      });

      this.markerList = [];
    },

    buildInfoWindowContent(item) {
      const data = item.data || {};

      return `
        <div style="width:260px;display:flex;flex-direction:column;line-height:1.5;">
          <div style="display:flex;flex-direction:row;">

            <div style="flex:0 0 80px;margin-right:10px;">
              <img
                src="${item.servicePic || ''}"
                style="
                  width:80px;
                  height:80px;
                  object-fit:cover;
                  border-radius:4px;
                "
              />
            </div>

            <div style="flex:1;">

              <div
                style="
                  font-weight:bold;
                  font-size:17px;
                  color:#484848;
                  margin-bottom:6px;
                "
              >
                ${data.title || "服务网点"}
              </div>

              <div style="margin:2px 0;">
                联系人：${data.linkMan || "--"}
              </div>

              <div style="margin:2px 0;color:#04b910;">
                电话：${data.serviceLandline || "--"}
              </div>

              <div
                style="
                  margin-top:4px;
                  color:#0060c9;
                  line-height:18px;
                "
              >
                地址:${data.address || "--"}
              </div>

            </div>

          </div>
        </div>
      `;
    },
  },

  watch: {
    markers: {
      handler() {
        if (!this.map || !this.T) return;
        this.addMarkers();
      },
      deep: true,
      immediate: true,
    },

    center: {
      handler(newVal) {
        if (!this.map || !this.T || !Array.isArray(newVal)) return;

        const point = new this.T.LngLat(Number(newVal[0]), Number(newVal[1]));
        this.map.panTo(point);
      },
      deep: true,
    },
  },
};
</script>